module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [(_vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema')) ? _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.$t('static.orders.shippingConfirm.unassignedProductError'),
      "type": "error",
      "show-icon": "",
      "closable": false
    }
  })], 1)], 1) : (_vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema')) ? _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [(_vm.displayError) ? _c('el-alert', {
    attrs: {
      "show-icon": "",
      "title": _vm.$t('static.orders.shippingConfirm.shippingProviderRequired'),
      "type": "error",
      "center": "",
      "closable": false
    }
  }, [(_vm.displayError) ? _c('div', {
    staticStyle: {
      "padding": "5px 0",
      "text-decoration": "underline"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/inventory/warehouse/" + _vm.warehouseId + "/edit#basics"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.orders.shippingConfirm.addShippingProviderBtn')))])], 1) : _vm._e()]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n          "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n        ")]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.shippingConfirm",
      "hasLabel": true
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema') ? true : false,
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65212321","hasScoped":false}!./src/app/components/ediOrderConfirmShipping/ediOrderConfirmShipping.html
// module id = 3040
// module chunks = 1